/** @jsxImportSource @emotion/react */
import styled from "@emotion/styled";
import React, { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import { deleteLabel, updateAllLabels } from "../../api/Label";
import { LabelAtom } from "../../atoms/LabelAtom";
import { notSelect } from "../../styles/general";
import { standardLabels } from "../../styles/labels";
import { ILabel } from "../../types/LabelTypes";
import SortableList from "../SortableList/SortableList";
import EditLabelCard from "./EditLabelCard";

const ModalBody = styled.div`
  max-width: 394px;
  min-width: 394px;
  max-height: 360px;
  min-height: 240px;

  overflow-y: auto;

  display: flex;
  flex-direction: column;
  align-items: center;

  border-top: 1px solid #eceeee;

  padding: 24px;
  margin: 18px -22px -25px;

  ${notSelect}

  @media screen and (max-width: 1024px) {
    width: 100vw;
    height: calc(100% - 94px);
    max-height: 100%;
    margin: 0;

    border-top: none;
  }
`;

interface Props {
  labels: ILabel[];
  removeLabel: (label: ILabel) => void;
}

export default function ManageLabel(props: Props): JSX.Element | null {
  const [flag, setFlag] = useState(false);
  const [labels, setLabels] = useRecoilState(LabelAtom);
  const [arrayLabels, setArrayLabels] = useState<ILabel[]>([]);

  async function deleteLabelHandler(id: string) {
    const newArrayLabel = labels?.filter((label: ILabel) => label._id !== id);

    if (!newArrayLabel) return;

    try {
      await deleteLabel(id);
    } catch (error) {
      console.log(error);
    }
    setLabels(newArrayLabel);
    setArrayLabels(newArrayLabel);
  }

  useEffect(() => {
    if (labels) setArrayLabels(labels);
    setFlag(!flag);
  }, [labels]);

  return (
    <ModalBody key={`${flag}`}>
      <SortableList
        items={arrayLabels}
        onDragEnd={async (items) => {
          let newLabels = items.map((label, index) => ({
            ...label,
            labelIndex: index,
          }));

          setLabels(newLabels);
          await updateAllLabels(newLabels);
        }}
      >
        {arrayLabels
          .slice()
          .sort((a, b) => a.labelIndex - b.labelIndex)
          .map((elem, index) => {
            const labelCss = standardLabels.find(
              ({ color }) => color === elem.color
            );

            return (
              <EditLabelCard
                key={`manage_label_card_${elem._id} + ${flag}`}
                id={index.toString()}
                index={index}
                labelCss={labelCss}
                label={elem}
                deleteLabel={(id: string) => deleteLabelHandler(id)}
              />
            );
          })}
      </SortableList>
    </ModalBody>
  );
}
